import { GridSize } from "@mui/material";

import { PartnerModel } from "./PartnerModel";
import { ServiceModel } from "./ServiceModel";
import { UserModel } from "./UserModel";

export type DeliveryAddressModel = {
  deliveryAddressCode: number;
  partnerCode: number;
  partner?: PartnerModel | null;
  serviceCode: string;
  service?: ServiceModel | null;
  name: string;
  city?: string | null;
  postalCode?: string | null;
  telephone?: string | null;
  streetName?: string | null;
  streetType?: string | null;
  houseNumber?: string | null;
  building?: string | null;
  staircase?: string | null;
  floor?: string | null;
  door?: string | null;
  parcelNumber?: string | null;
  updatedBy?: string | null;
  updatedByUser?: UserModel | null;
  updatedAt?: string | null;
  //casted data
  fullAddress?: string | null;
};

export type DeliveryAddressGridKey = {
  label: string;
  key: string;
  inputHidden?: true | null;
  displayDisabled?: true | null;
  md?: GridSize | null;
  sm?: GridSize | null;
  xs?: GridSize | null;
  align?: "inherit" | "left" | "right" | "center" | "justify" | null;
};

export const gridKeys: DeliveryAddressGridKey[] = [
  { label: "Üzlet/Telephely neve", key: "name" },
  { label: "Cím", key: "fullAddress", inputHidden: true },
  { label: "Irányítószám", key: "postalCode", displayDisabled: true },
  { label: "Város", key: "city", displayDisabled: true },
  { label: "Közterület neve", key: "streetName", displayDisabled: true },
  { label: "Közterület jellege", key: "streetType", displayDisabled: true },
  { label: "Házszám", key: "houseNumber", displayDisabled: true },
  { label: "Épület", key: "building", displayDisabled: true },
  { label: "Lépcsőház", key: "staircase", displayDisabled: true },
  { label: "Emelet", key: "floor", displayDisabled: true },
  { label: "Ajtó", key: "door", displayDisabled: true },
  { label: "Helyrajzi szám", key: "parcelNumber", displayDisabled: true },
];
